import React, { Component } from 'react'
import { Alert } from "react-bootstrap";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Select from 'react-select';
import { api } from "api";
import toastr from "toastr";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { head } from 'lodash';
import { height } from '@amcharts/amcharts4/.internal/core/utils/Utils';

class KocAilemMembership extends Component {
    state = {
        cities: [],
        homeDistricts: [],
        workDistricts: [],
        kocAilemEntityId: null,
        fatherName: null,
        motherName: null,
        homeZipCode: null,
        homeCityCode: null,
        homeDistrictCode: null,
        homeAddress: null,
        workZipCode: null,
        workCityCode: null,
        workDistrictCode: null,
        workAddress: null,
        workPhone: null,
        genderCode: null,
        maritalStatusCode: null,
        mobilePhone: null,
        isKocAilemApproved: null,
        isRegistered: null,
        isMobilePhoneNumberValidated: null,
        isWorkPhoneNumberValidated: null,
        isError: "none",
        isSuccess: "none",
        isWait: "none"
    }
    componentDidMount() {
        this.fetchCities();
        this.fetchKocAilemMemberData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.homeCityCode != this.state.homeCityCode) {
            this.fetchDistricts(this.state.homeCityCode, "home")
        }
        if (prevState.workCityCode != this.state.workCityCode) {
            this.fetchDistricts(this.state.workCityCode, "work")
        }

        if (prevState.isKocAilemApproved != null && prevState.isKocAilemApproved != this.state.isKocAilemApproved) {
            this.updateKocAilemMemberApproveCode();
        }

        if (prevState.mobilePhone != this.state.mobilePhone) {
            this.handleMobilePhoneChange(this.state.mobilePhone);
        }
        if (prevState.workPhone != this.state.workPhone) {
            this.handleWorkPhoneChange(this.state.workPhone);
        }
    }

    checkFields = () => {
        if (this.state.fatherName &&
            this.state.motherName &&
            this.state.homeZipCode &&
            this.state.homeCityCode &&
            this.state.homeDistrictCode &&
            this.state.homeAddress &&
            this.state.workZipCode &&
            this.state.workCityCode &&
            this.state.workDistrictCode &&
            this.state.workAddress &&
            this.state.workPhone &&
            this.state.genderCode &&
            this.state.maritalStatusCode &&
            this.state.mobilePhone) {
            return false;
        }
        return true;
    }

    updateKocAilemMember = () => {
        this.setState({ isRegistered: true });
        this.props.onProcessBegin();
        api.post("api/profile/update-koc-ailem-member", {
            id: this.state.kocAilemEntityId,
            fatherName: this.state.fatherName,
            motherName: this.state.motherName,
            homeAddressZipCode: this.state.homeZipCode,
            homeAddressCityCode: this.state.homeCityCode,
            homeAddressDistrictCode: this.state.homeDistrictCode,
            homeAddress: this.state.homeAddress,
            workAddressZipCode: this.state.workZipCode,
            workAddressCityCode: this.state.workCityCode,
            workAddressDistrictCode: this.state.workDistrictCode,
            workAddress: this.state.workAddress,
            workPhone: "90/" + this.state.workPhone,
            genderCode: this.state.genderCode,
            maritalStatusCode: this.state.maritalStatusCode,
            mobilePhone: "90/" + this.state.mobilePhone,
            isRegistered: this.state.isRegistered
        }).then((response) => {
            if (response.status == 204) {
                toastr.success(i18next.t("10537"));
                this.setState({ isSuccess: "block" });

                this.setState({ isError: "none" });
                this.setState({ isWait: "none" });
            }
        }).catch((err) => {
            toastr.error(i18next.t("10538"));
            console.error(err);
            this.setState({ isError: "block" });


            this.setState({ isSuccess: "none" });
            this.setState({ isWait: "none" });

        }).finally(() => {
            this.props.onProcessEnd();
        });
    }

    updateKocAilemMemberApproveCode = () => {
        this.props.onProcessBegin();
        api.post("api/profile/update-koc-ailem-member-approve-code", {
            id: this.state.kocAilemEntityId,
            isApproved: this.state.isKocAilemApproved,
        }).then((response) => {
            if (response.status == 204) {
                toastr.success(i18next.t("10537"));
                this.setState({ isSuccess: "block" });

                this.setState({ isError: "none" });
                this.setState({ isWait: "none" });
            }
        }).catch((err) => {
            toastr.error(i18next.t("10538"));
            this.setState({ isError: "block" });

            this.setState({ isSuccess: "none" });
            this.setState({ isWait: "none" });

            console.error(err);
        }).finally(() => {
            this.props.onProcessEnd();
        });
    }

    fetchKocAilemMemberData = () => {
        api.get(`api/profile/get-koc-ailem-member`)
            .then((response) => {

                let newWorkPhone = response.data.data.workPhone;
                if (newWorkPhone != null) {
                    newWorkPhone = response.data.data.workPhone.includes("90/") ? response.data.data.workPhone.substring(3, response.data.data.workPhone.length) : response.data.data.workPhone;
                }

                let newMobilePhone = response.data.data.mobilePhone;
                if (newMobilePhone != null) {
                    newMobilePhone = response.data.data.mobilePhone.includes("90/") ? response.data.data.mobilePhone.substring(3, response.data.data.mobilePhone.length) : response.data.data.mobilePhone;
                }

                if (response.data.data.memberapprovedcode?.value == 1) {
                    this.setState({ isSuccess: "block" });

                    this.setState({ isError: "none" });
                    this.setState({ isWait: "none" });
                }
                else if (response.data.data.memberapprovedcode?.value == 2) {
                    this.setState({ isError: "block" });

                    this.setState({ isSuccess: "none" });
                    this.setState({ isWait: "none" });
                }
                else if (response.data.data.memberapprovedcode?.value == 3) {
                    this.setState({ isWait: "block" });

                    this.setState({ isSuccess: "none" });
                    this.setState({ isError: "none" });
                }




                this.setState({
                    kocAilemEntityId: response.data.data.id,
                    fatherName: response.data.data.fatherName,
                    motherName: response.data.data.motherName,
                    homeZipCode: response.data.data.homeAddressZipCode,
                    homeCityCode: response.data.data.homeAddressCityCode,
                    homeDistrictCode: response.data.data.homeAddressDistrictCode,
                    homeAddress: response.data.data.homeAddress,
                    workZipCode: response.data.data.workAddressZipCode,
                    workCityCode: response.data.data.workAddressCityCode,
                    workDistrictCode: response.data.data.workAddressDistrictCode,
                    workAddress: response.data.data.workAddress,
                    workPhone: newWorkPhone,
                    genderCode: response.data.data.gender?.value,
                    maritalStatusCode: response.data.data.maritalStatus?.value,
                    mobilePhone: newMobilePhone,
                    isKocAilemApproved: response.data.data.kocAilemApproveCode?.value == 1 ? true : false,
                    isRegistered: response.data.data.isRegistered
                });
            })
            .catch((err) => {
                console.error(err);
            });
    }

    fetchCities = () => {
        api.get(`api/profile/get-cities`)
            .then((response) => {
                this.setState({ cities: response.data.data.cities });
            })
            .catch((err) => {
                console.error(err);
            });
    }

    fetchDistricts = (cityCode, type) => {
        api.get(`api/profile/get-districts/${cityCode}`)
            .then((response) => {
                if (type === "home") {
                    this.setState({ homeDistricts: response.data.data.districts });
                }
                else {
                    this.setState({ workDistricts: response.data.data.districts });
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    handleMobilePhoneChange = (e) => {
        if (("90/" + e).match(/^90\/(\d{3})\/(\d{7})$/)) {
            this.setState({ mobilePhone: e, isMobilePhoneNumberValidated: true });
        }
        else {
            this.setState({ mobilePhone: e, isMobilePhoneNumberValidated: false });
        }
    }

    handleWorkPhoneChange = (e) => {
        if (("90/" + e).match(/^90\/(\d{3})\/(\d{7})(?:\/\d{3,})?$/)) {
            this.setState({ workPhone: e, isWorkPhoneNumberValidated: true });
        }
        else {
            this.setState({ workPhone: e, isWorkPhoneNumberValidated: false });
        }
    }

    genders = [{ value: 50178, label: i18next.t("10755") }, { value: 50179, label: i18next.t("10756") }];
    maritalStatuses = [{ value: 50264, label: i18next.t("10767") }, { value: 50266, label: i18next.t("10768") }];

    render() {
        return (
            <div>
                <div className="row">
                    <h6 className="col-12 col-sm-12 col-md-12 col-lg-12 koc-ailem-header"><Trans desc="Koç Ailem Üyelik Onayı">10770</Trans></h6>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group koc-ailem-kvkk-text">
                            <p><Trans desc="Koç Ailem Programına başvurmanız halinde Şirketimiz kimlik bilgilerinizi, iletişim bilgilerinizi...">10772</Trans></p>
                            <div className="custom-control custom-checkbox" style={{ float: "left", width: "50%" }}>
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="kocAilemKvkkCheck"
                                    checked={this.state.isKocAilemApproved ?? false}
                                    onChange={(e) => { this.setState({ isKocAilemApproved: e.currentTarget.checked }) }}
                                    disabled={this.state.isKocAilemApproved ?? false}
                                />
                                <label className="custom-control-label pl-0 formClickArea checkbox-label" htmlFor="kocAilemKvkkCheck">
                                    <span><Trans desc="Koç Ailem üyelik bilgilerimin KVKK kapsamında işlenmesine izin veriyorum.">10771</Trans></span>
                                </label>
                            </div>
                            <div className='genwarn' title={i18next.t("10538")} style={{ display: this.state.isError }}>
                                <img src='/img/warning.png' style={{ width: 32, height: 32 }}></img> <span style={{ verticalAlign: "sub" }}>{i18next.t("10538")}</span>
                            </div>
                            <div title={i18next.t("10537")} style={{ display: this.state.isSuccess, color: "green", textAlign: "right" }}>
                                <img src='/img/success.png' style={{ width: 25, height: 25 }}></img> <span style={{ verticalAlign: "bottom" }}>{i18next.t("10537")}</span>
                            </div>
                            <div title={i18next.t("isWait")} style={{ display: this.state.isWait, color: "#012f6d", textAlign: "right" }}>
                                <span style={{ verticalAlign: "bottom", fontWeight: "bold", fontSize: "16px" }}>{i18next.t("isWait")}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.isKocAilemApproved && <div>
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="profilAreaRowSeperator"></div>
                        </div>
                        <h6 className="col-12 col-sm-12 col-md-12 col-lg-12 koc-ailem-header"><Trans desc="Kişisel Bilgiler">10753</Trans></h6>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="cinsiyet">
                                    <Trans desc="Cinsiyet">10754</Trans>
                                </label>
                                <div className="inner-addon right-addon custom-react-select">
                                    <Select
                                        name="cinsiyet"
                                        options={this.genders}
                                        onChange={(e) => this.setState({ genderCode: e.value })}
                                        value={this.genders.find((o) => o.value === this.state.genderCode)}
                                        isDisabled={this.state.isRegistered}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="medenidurum">
                                    <Trans desc="Medeni Durumu">10766</Trans>
                                </label>
                                <div className="inner-addon right-addon custom-react-select">
                                    <Select
                                        name="medenidurum"
                                        options={this.maritalStatuses}
                                        onChange={(e) => this.setState({ maritalStatusCode: e.value })}
                                        value={this.maritalStatuses.find((o) => o.value === this.state.maritalStatusCode)}
                                        isDisabled={this.state.isRegistered}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="mobil" style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Trans desc="Telefon">10769</Trans>
                                    <span style={{ color: "#f00", textAlign: "right" }}>  * Örnek (555/4443322)</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="mobil"
                                    value={this.state.mobilePhone ?? ""}
                                    onChange={(e) => {



                                        if (e.target.value === "0") {
                                            e.target.value = e.target.value.replace(/^0/, "");
                                        }
                                        else {
                                            var a = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                                            e.target.value = !a[2] ? a[1] : a[1] + '/' + a[2] + (a[3] ? a[3] : '');
                                            this.handleMobilePhoneChange(e.target.value);
                                        }

                                    }}
                                    disabled={this.state.isRegistered}
                                    placeholder='555/4443322'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="profilAreaRowSeperator"></div>
                        </div>
                        <h6 className="col-12 col-sm-12 col-md-12 col-lg-12 koc-ailem-header"><Trans desc="Aile Bilgileri">10745</Trans></h6>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="form-group">
                                <label htmlFor="babaadi">
                                    <Trans desc="Baba Adı">10740</Trans>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="babaadi"
                                    value={this.state.fatherName ?? ""}
                                    onChange={(e) => {
                                        this.setState({ fatherName: e.target.value });
                                    }}
                                    disabled={this.state.isRegistered}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="form-group">
                                <label htmlFor="anaadi">
                                    <Trans desc="Ana Adı">10741</Trans>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="anaadi"
                                    value={this.state.motherName ?? ""}
                                    onChange={(e) => {
                                        this.setState({ motherName: e.target.value });
                                    }}
                                    disabled={this.state.isRegistered}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="profilAreaRowSeperator"></div>
                        </div>
                        <h6 className="col-12 col-sm-12 col-md-12 col-lg-12 koc-ailem-header"><Trans desc="Ev Adresi Bilgileri">10746</Trans></h6>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="evil">
                                    <Trans desc="İl">10742</Trans>
                                </label>
                                <div className="inner-addon right-addon custom-react-select">
                                    <Select
                                        name="evil"
                                        options={this.state.cities}
                                        onChange={(e) => this.setState({ homeCityCode: e.value })}
                                        value={this.state.cities.find((o) => o.value === this.state.homeCityCode)}
                                        isDisabled={this.state.isRegistered}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="evilce">
                                    <Trans desc="İlçe">10743</Trans>
                                </label>
                                <div className="inner-addon right-addon custom-react-select">
                                    <Select
                                        name="evilce"
                                        options={this.state.homeDistricts}
                                        onChange={(e) => this.setState({ homeDistrictCode: e.value })}
                                        value={this.state.homeDistricts.find((o) => o.value === this.state.homeDistrictCode)}
                                        isDisabled={this.state.isRegistered}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label htmlFor="evpostakod">
                                    <Trans desc="Posta Kodu">10744</Trans>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="evpostakod"
                                    value={this.state.homeZipCode ?? ""}
                                    onChange={(e) => {
                                        this.setState({ homeZipCode: e.target.value });
                                    }}
                                    disabled={this.state.isRegistered}
                                    placeholder='01234'
                                    maxLength={5}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                                <label htmlFor="evadres">
                                    <Trans desc="Adres ">10747</Trans>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="evadres"
                                    value={this.state.homeAddress ?? ""}
                                    onChange={(e) => {
                                        this.setState({ homeAddress: e.target.value });
                                    }}
                                    disabled={this.state.isRegistered}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="profilAreaRowSeperator"></div>
                        </div>
                        <h6 className="col-12 col-sm-12 col-md-12 col-lg-12 koc-ailem-header"><Trans desc="İş Adresi Bilgileri">10748</Trans></h6>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="isil">
                                    <Trans desc="İl">10742</Trans>
                                </label>
                                <div className="inner-addon right-addon custom-react-select">
                                    <Select
                                        name="isil"
                                        options={this.state.cities}
                                        onChange={(e) => this.setState({ workCityCode: e.value })}
                                        value={this.state.cities.find((o) => o.value === this.state.workCityCode)}
                                        isDisabled={this.state.isRegistered}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="isilce">
                                    <Trans desc="İlçe">10743</Trans>
                                </label>
                                <div className="inner-addon right-addon custom-react-select">
                                    <Select
                                        name="isilce"
                                        options={this.state.workDistricts}
                                        onChange={(e) => this.setState({ workDistrictCode: e.value })}
                                        value={this.state.workDistricts.find((o) => o.value === this.state.workDistrictCode)}
                                        isDisabled={this.state.isRegistered}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="ispostakod">
                                    <Trans desc="Posta Kodu">10744</Trans>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="ispostakod"
                                    value={this.state.workZipCode ?? ""}
                                    onChange={(e) => {
                                        this.setState({ workZipCode: e.target.value });
                                    }}
                                    disabled={this.state.isRegistered}
                                    placeholder='01234'
                                    maxLength={5}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="istelefon" style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Trans desc="İş Telefonu">10749</Trans>
                                    <span style={{ color: "#f00", textAlign: "right" }}>  * Örnek (512/3456789/123)</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="istelefon"
                                    value={this.state.workPhone ?? ""}
                                    onChange={(e) => {
                                        if (e.target.value === "0") {
                                            e.target.value = e.target.value.replace(/^0/, "");
                                        }
                                        else {
                                            var a = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,3})/);
                                            e.target.value = !a[2] ? a[1] : a[1] + '/' + a[2] + (a[3] ? a[3] : '') + (a[4] ? '/' + a[4] : '');
                                            this.handleWorkPhoneChange(e.target.value);
                                        }
                                    }}
                                    disabled={this.state.isRegistered}
                                    placeholder='512/3456789/123'
                                />
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">
                                <label htmlFor="isadres">
                                    <Trans desc="Adres ">10747</Trans>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="isadres"
                                    value={this.state.workAddress ?? ""}
                                    onChange={(e) => {
                                        this.setState({ workAddress: e.target.value });
                                    }}
                                    disabled={this.state.isRegistered}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-12 col-md-12 col-lg-12'>
                        <div className="profilAreaRowSeperator"></div>
                        {
                            this.checkFields() ?
                                <div className="col-sm-12 col-md-12 col-lg-12" style={{ display: "inline-block" }}>
                                    <Alert variant="danger">{i18next.t("10750")}</Alert>
                                </div> : null
                        }
                        {
                            !this.state.isRegistered ?
                                <div className="col-sm-12 col-md-12 col-lg-12 text-right" style={{ display: "inline-block" }}>
                                    <button
                                        type="button"
                                        className="btn btn-kaydet"
                                        onClick={() => this.updateKocAilemMember()}
                                        disabled={this.checkFields() || !this.state.isMobilePhoneNumberValidated || !this.state.isWorkPhoneNumberValidated}
                                    >
                                        <Trans desc="Kaydet">10328</Trans>
                                    </button>
                                </div> : <div />


                            // <div className="col-sm-12 col-md-12 col-lg-12" style={{ display: "inline-block" }}>
                            //     <Alert variant="info">{i18next.t("10765")}</Alert>
                            // </div>
                        }
                    </div>
                </div>
                }
            </div>
        )
    }
}
export default requireAuth(containsLongRunningProcess(KocAilemMembership));
